import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Bar, BarWrap, Container, Item } from './styled';
import { Block, Tag, Label } from '../../..';
import icon from '../../../../../assets/icons/iconVirtual.svg';
import Icon from '../../../Icon';
import RangeBar from '../RangeBar';
import { LeftPanel, ListVirtualCourses, RightPanel } from './partials';

interface IProps {
  handleSelectRanges: any;
  isClass?: boolean;
  isClickOut: any;
  ranges: any[];
  selectedDate: any;
  virtualCourses?: any[];
  // schedule: any
}

const BarHeader = ({
  handleSelectRanges,
  isClass,
  isClickOut,
  ranges,
  selectedDate,
  virtualCourses
}: IProps) => {
  const [openVirtual, setOpenVirtual] = useState(false);
  const handlerSetOpenVirtual = (open: boolean) => {
    if (isMobile) setOpenVirtual(open);
  };
  return (
    <Block style={{ backgroundColor: '#fbfdff' }} data-testid="cmp-bar-header">
      <Container>
        <BarWrap>
          {virtualCourses && virtualCourses.length > 0 && (
            <Bar>
              {isMobile ? (
                <Block
                  flex
                  style={{ justifyContent: 'space-between', padding: 8 }}
                >
                  <Block flex style={{ flexDirection: 'column' }}>
                    <Block>
                      <ListVirtualCourses
                        virtualCourses={virtualCourses}
                        isClickOut={isClickOut}
                        openVirtual={openVirtual}
                        isClass={isClass}
                      />
                      <Block
                        style={{ display: 'flex', flexDirection: 'column' }}
                      >
                        {' '}
                        {/* display: 'inline-flex' */}
                        <Tag
                          backgroundColor="var(--background-tag-background10)"
                          color="var(--decorative-decorative01)"
                          padding="4px 12px"
                          margin="0px 8px 4px 0px"
                          size={12}
                          bold
                          radius={20}
                        >
                          <Label
                            text="Virtual 24/7"
                            bold
                            color="var(--decorative-decorative10)"
                            size={12}
                          />
                        </Tag>
                        {virtualCourses.length > 1 && (
                          <Label
                            text={`${virtualCourses?.length} Cursos`}
                            black
                            color="#FFFFFF"
                            size={14}
                            lineHeight={20}
                          />
                        )}
                      </Block>
                    </Block>
                    <Block>
                      <Label
                        fontWeight="400"
                        color="#ffffff"
                        size={14}
                        text="Disponible 24/7"
                        lineHeight={20}
                      />
                      <Block
                        flex
                        style={{
                          justifyContent: 'flex-end',
                          alignItems: 'center'
                        }}
                      >
                        <img
                          src={icon}
                          alt="Logo"
                          style={{ height: 20, paddingRight: '6px' }}
                        />
                        <Label
                          color="#ffffff"
                          bold
                          size={14}
                          text={isClass ? 'UTP + Class' : 'Canvas'}
                          marginLeft={0}
                          marginRight={6}
                          lineHeight={20}
                        />
                      </Block>
                    </Block>
                  </Block>
                  <Block>
                    <Item>
                      {virtualCourses.length > 1 && (
                        <button
                          type="button"
                          data-testid="cmp-button-item"
                          className="buttonInteraction fadeTransition"
                          onClick={() => {
                            handlerSetOpenVirtual(!openVirtual);
                          }}
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '12px 0px'
                          }}
                        >
                          {!openVirtual ? (
                            <>
                              <Icon
                                name="chevron-down"
                                size={25}
                                color="#fff"
                              />
                              <Label
                                color="#ffffff"
                                bold
                                size={14}
                                text="Ver cursos"
                                marginLeft={8}
                                marginRight={6}
                                lineHeight={20}
                              />
                            </>
                          ) : (
                            <>
                              <Icon name="chevron-up" size={25} color="#fff" />
                              <Label
                                color="#ffffff"
                                bold
                                size={14}
                                text="Ocultar cursos"
                                marginLeft={8}
                                marginRight={6}
                                lineHeight={20}
                              />
                            </>
                          )}
                        </button>
                      )}
                    </Item>
                  </Block>
                </Block>
              ) : (
                <>
                  <div>
                    <LeftPanel
                      openVirtual={openVirtual}
                      count={virtualCourses?.length}
                    />
                  </div>
                  <div>
                    <ListVirtualCourses
                      virtualCourses={virtualCourses}
                      isClickOut={isClickOut}
                      openVirtual={openVirtual}
                    />
                  </div>
                  <div>
                    <RightPanel
                      openVirtual={openVirtual}
                      count={virtualCourses?.length}
                    />
                  </div>
                </>
              )}
            </Bar>
          )}
          <RangeBar
            isMobile={isMobile}
            ranges={ranges}
            handleSelect={handleSelectRanges}
            selectedDate={selectedDate}
          />
        </BarWrap>
      </Container>
    </Block>
  );
};

export default BarHeader;
